// eslint-disable-next-line no-use-before-define
import React, { ReactElement, useEffect, useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { config } from 'core/config';
import { baseUrlUser, successNotificationWith } from 'utils/api';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/combineReducers';
import { getStoredSource } from 'utils/localStorage';
import { getPostLoginPath, removePostLoginPath } from 'utils/postLogin';
import { RolesEnum } from 'core/models';

export default function LoginRedirect(): ReactElement {
  const sourcePath = getStoredSource();
  // const isDownload = sourcePath && sourcePath.startsWith(config.paths.download);
  const { user } = useSelector((state: ApplicationState) => state.session);
  // useEffect(() => {
  //   if (isDownload || !user?.email) {
  //     return;
  //   }
  // }, [user, isDownload]);
  // redirect source
  // if (!user || !user.roles) {
  //   return <div />;
  // }
  // A page the visitor was sent to before signing in wins over the SSO
  // sourcePath: it is the more specific intent, and it is the only one that can
  // carry an OAuth request_id.
  //
  // Read without clearing, then clear in an effect. Consuming it during render
  // would be a side effect in the render path, and a double render - which
  // StrictMode does deliberately in development - would blank it before the
  // Redirect below ever saw it.
  const postLoginPath = getPostLoginPath();
  useEffect(() => {
    if (postLoginPath) {
      removePostLoginPath();
    }
  }, [postLoginPath]);
  if (postLoginPath) {
    return <Redirect to={postLoginPath} />;
  }
  if (sourcePath) {
    return <Redirect to={sourcePath} />;
  }
  // redirect user
  return <Redirect to={baseUrlUser(user?.roles[0]?.name)} />;
}
